/* tslint:disable */
import * as Types from '../../../../../../graphql-api/baskets-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type OrderQueryVariables = Types.Exact<{
  orderNumber: Types.Scalars['String']['input'];
  accountIds?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
}>;


export type OrderQuery = { order?: Array<{ id: string, title?: string | null, rootId?: string | null, rootTitle?: string | null, markup?: number | null, displayedProductId?: string | null, brandId?: string | null, colorText?: string | null, requestedDeliveryDate?: string | null, confirmedDeliveryDate?: string | null, shippingDeliveryDate?: string | null, discountPercentage?: number | null, requestedQuantity?: number | null, confirmedQuantity?: number | null, deliveredQuantity?: number | null, unconfirmedQuantity?: number | null, salesOrderNumber?: string | null, deliveryNumbers?: Array<string | null> | null, trackingNumbers?: Array<string | null> | null, invoiceNumbers?: Array<string | null> | null, priceGross?: { currency?: string | null, value?: number | null } | null, unitPriceGross?: { currency?: string | null, value?: number | null } | null, priceNet?: { currency?: string | null, value?: number | null } | null, priceNetConfirmed?: { currency?: string | null, value?: number | null } | null, unitPriceNet?: { currency?: string | null, value?: number | null } | null, priceRrp?: { currency?: string | null, value?: number | null } | null, unitPriceRrp?: { currency?: string | null, value?: number | null } | null, discount?: { currency?: string | null, value?: number | null } | null, unitDiscount?: { currency?: string | null, value?: number | null } | null, variants?: Array<{ type?: string | null, requestedDeliveryDate?: string | null, confirmedDeliveryDate?: string | null, shippingDeliveryDate?: string | null, submittedDeliveryDate?: string | null, requestedQuantity?: number | null, confirmedQuantity?: number | null, deliveredQuantity?: number | null, unconfirmedQuantity?: number | null, discountPercentage?: number | null, markup?: number | null, rootId?: string | null, priceGross?: { currency?: string | null, value?: number | null } | null, unitPriceGross?: { currency?: string | null, value?: number | null } | null, priceNet?: { currency?: string | null, value?: number | null } | null, unitPriceNet?: { currency?: string | null, value?: number | null } | null, priceRrp?: { currency?: string | null, value?: number | null } | null, unitPriceRrp?: { currency?: string | null, value?: number | null } | null, discount?: { currency?: string | null, value?: number | null } | null, unitDiscount?: { currency?: string | null, value?: number | null } | null, sizes?: Array<{ width?: string | null, title?: string | null, count?: number | null, requestedQuantity?: number | null, confirmedQuantity?: number | null, deliveredQuantity?: number | null, unconfirmedQuantity?: number | null, unitPriceNet?: { currency?: string | null, value?: number | null } | null } | null> | null } | null> | null } | null> | null };

export const OrderDocument = gql`
    query Order($orderNumber: String!, $accountIds: [String]) {
  order(orderNumber: $orderNumber, accountIds: $accountIds) {
    id
    title
    rootId
    rootTitle
    markup
    displayedProductId
    brandId
    colorText
    requestedDeliveryDate
    confirmedDeliveryDate
    shippingDeliveryDate
    priceGross {
      currency
      value
    }
    unitPriceGross {
      currency
      value
    }
    priceNet {
      currency
      value
    }
    priceNetConfirmed {
      currency
      value
    }
    unitPriceNet {
      currency
      value
    }
    priceRrp {
      currency
      value
    }
    unitPriceRrp {
      currency
      value
    }
    discount {
      currency
      value
    }
    unitDiscount {
      currency
      value
    }
    discountPercentage
    requestedQuantity
    confirmedQuantity
    deliveredQuantity
    unconfirmedQuantity
    salesOrderNumber
    deliveryNumbers
    trackingNumbers
    invoiceNumbers
    shippingDeliveryDate
    variants {
      type
      requestedDeliveryDate
      confirmedDeliveryDate
      shippingDeliveryDate
      submittedDeliveryDate
      requestedQuantity
      confirmedQuantity
      deliveredQuantity
      unconfirmedQuantity
      priceGross {
        currency
        value
      }
      unitPriceGross {
        currency
        value
      }
      priceNet {
        currency
        value
      }
      unitPriceNet {
        currency
        value
      }
      priceRrp {
        currency
        value
      }
      unitPriceRrp {
        currency
        value
      }
      discount {
        currency
        value
      }
      unitDiscount {
        currency
        value
      }
      discountPercentage
      markup
      rootId
      sizes {
        width
        title
        count
        requestedQuantity
        confirmedQuantity
        deliveredQuantity
        unconfirmedQuantity
        unitPriceNet {
          currency
          value
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderGQL extends Apollo.Query<OrderQuery, OrderQueryVariables> {
    document = OrderDocument;
    client = 'baskets';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }